import { GuardedType, isString } from "generic-type-guard";

import { createDescriptorFunctions } from "@de.skhh.modulf/client-core";

export const OpenregisterSearchModalDescriptor = createDescriptorFunctions(
	{
		modal: "OpenregisterSearchModal"
	} as const,
	{
		openregisterPath: isString,
		mappingConfigurationId: isString,
		sourceActivityId: isString
	}
);

export type OpenregisterSearchModalDescriptor = GuardedType<typeof OpenregisterSearchModalDescriptor.isInstance>;
